import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { ProtectedRoute, AdminRoute } from './components/RouteGuards';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Patients } from './pages/Patients';
import { PatientForm } from './pages/PatientForm';
import { PatientDetail } from './pages/PatientDetail';
import { EsdmLevels } from './pages/EsdmLevels';
import { EsdmLevelDomains } from './pages/EsdmLevelDomains';
import { EsdmDomain } from './pages/EsdmDomain';
import { EsdmReport } from './pages/EsdmReport';
import { Relatorios } from './pages/Relatorios';
import { RelatorioConsolidado } from './pages/RelatorioConsolidado';
import { Users } from './pages/admin/Users';
import { Therapists } from './pages/admin/Therapists';
import { TherapistForm } from './pages/admin/TherapistForm';
import { TherapistDetail } from './pages/admin/TherapistDetail';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            element={
              <ProtectedRoute>
                <DataProvider>
                  <Layout />
                </DataProvider>
              </ProtectedRoute>
            }
          >
            <Route path="/patients" element={<Patients />} />
            <Route path="/patients/new" element={<PatientForm />} />
            <Route path="/patients/:id" element={<PatientDetail />} />
            <Route path="/patients/:id/edit" element={<PatientForm />} />
            <Route path="/patients/:id/esdm" element={<EsdmLevels />} />
            <Route path="/patients/:id/esdm/report" element={<EsdmReport />} />
            <Route path="/patients/:id/esdm/:level" element={<EsdmLevelDomains />} />
            <Route path="/patients/:id/esdm/:level/:domain" element={<EsdmDomain />} />

            <Route path="/relatorios" element={<Relatorios />} />
            <Route path="/relatorios/:id" element={<RelatorioConsolidado />} />

            <Route
              path="/admin/users"
              element={
                <AdminRoute>
                  <Users />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/therapists"
              element={
                <AdminRoute>
                  <Therapists />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/therapists/new"
              element={
                <AdminRoute>
                  <TherapistForm />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/therapists/:uid"
              element={
                <AdminRoute>
                  <TherapistDetail />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/therapists/:uid/edit"
              element={
                <AdminRoute>
                  <TherapistForm />
                </AdminRoute>
              }
            />
          </Route>

          <Route path="/" element={<Navigate to="/patients" replace />} />
          <Route path="*" element={<Navigate to="/patients" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
